import { withStyles } from "@material-ui/core";
import styles from "./styles";
import React from "react";
import { NavLink } from "react-router-dom";
import { SHARED_IMAGE_BASE_URL } from "../../constants/ui";

function SharedItem(props){
  const { item, classes } = props;
  return (
    <div className={classes.boxPage}>
      <div className={classes.boxImg}>
        <NavLink
          title={item.name}
          to={{
            pathname: `/chia-se/chi-tiet/${item.alias}`,
            state: { item }
          }}
        >
          <img src={`${SHARED_IMAGE_BASE_URL}/${item.picture}`} alt={item.name} />
        </NavLink>
      </div>
      <div className={classes.boxDetail}>
        <h4>
          <NavLink
            title={item.seo_title}
            to={{
              pathname: `/chia-se/chi-tiet/${item.alias}`,
              state: { item }
            }}
          >
            {item.name}
          </NavLink>
        </h4>
        <h5>{item.seo_description}</h5>
      </div>
    </div>
  );
}

export default withStyles(styles)(SharedItem);